module.exports = __webpack_public_path__ + "static/media/img_21.8d8593c1.png";